export default __webpack_public_path__ + "static/2-9a0163f69c95671c5d729fa301dc18ce.jpeg";